import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(email, password) {
    return axios.post(`${Constants.baseUrl}/auth`, { email, password });
}

export function forgotPassword(email) {
    return axios.post(`${Constants.baseUrl}/forgot-password`, { email });
}

export function forgotPasswordCode(payload) {
    return axios.post(`${Constants.baseUrl}/forgot-password-code`, payload);
}

export function resetPassword(data) {
    return axios.post(`${Constants.baseUrl}/reset-password`, data);
}

export function getPlans() {
    return axios.get(`${Constants.url}/planos`);
}

export function signin(payload) {
    return axios.post(`${Constants.baseUrl}/signin`, payload);
}

export function validateCoupon(code) {
    return axios.get(`${Constants.url}/cupom-desconto/validate`, { params: { code } });
}

export function logout() {
    return axios.post(`${Constants.baseUrl}/logout`);
}
